import axios from "axios";
import { API_URL } from "../../../core/config/env";
import { getHeaders, processError } from "../../../core/helpers/service-helper";

export const crearOEditarRecurso = async (recurso) => {
    try {
        const resp = await axios.post(`${API_URL}/reservas/recursos`, recurso, {
            headers: getHeaders(),
        });

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

export const cambiarEstadoRecurso = async (idRecurso, estado) => {
    try {
        const resp = await axios.put(
            `${API_URL}/reservas/recursos/cambiarEstado/${idRecurso}`,
            { estado },
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};
